<div class="host-message-container">
  <!-- 右侧的消息 -->
  <div class="right-panel-container">
    <host-message
      *ngFor="let message of rightMessages"
      [message]="message"
      (removeMessage)="removeMessage($event)"
      (replaceMessage)="replaceMessage($event.id, $event.data)"></host-message>
  </div>
  <!-- 中间的消息 -->
  <div class="center-panel-container">
    <ng-container *ngFor="let message of centerMessages">
      <host-message
        *ngIf="hideMessagesMap[message.type] !== message.status"
        [position]="'center'"
        [message]="message"
        (removeMessage)="removeMessage($event)"
        (replaceMessage)="replaceMessage($event.id, $event.data, $event.option)"
        (hideMessage)="hideMessage($event)"></host-message>
    </ng-container>

  </div>
</div>
